import { IconName } from '@infotech-soe/erp-ui-kit';
import { ActionProcessMode } from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../infrastructure/providers/abstract/IApiProvider';
import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';

import CategoryCommand, { RefreshStrategy } from './CategoryCommand';

class WeakenLinksCommand extends CategoryCommand<TActionArgsValues> {
  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.WEAKEN_LINK,
    };
  }

  public getIcon(): IconName {
    return 'unlink';
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.CURRENT;
  }

  public getProcessMode(): ActionProcessMode {
    return 'Sequential';
  }
}

export default WeakenLinksCommand;
